const isPostalCode = /^[0-9]{3}\s?[0-9]{2}$/;

export default isPostalCode;
